export * from "./PollyClient";
export * from "./Polly";
export * from "./commands/DeleteLexiconCommand";
export * from "./commands/DescribeVoicesCommand";
export * from "./commands/GetLexiconCommand";
export * from "./commands/GetSpeechSynthesisTaskCommand";
export * from "./commands/ListLexiconsCommand";
export * from "./commands/ListSpeechSynthesisTasksCommand";
export * from "./commands/PutLexiconCommand";
export * from "./commands/StartSpeechSynthesisTaskCommand";
export * from "./commands/SynthesizeSpeechCommand";
export * from "./models/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/client-polly/dist/es/index.js
// module id = null
// module chunks = 